webpackJsonp([165],{

/***/ 116:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(980),
  /* template */
  __webpack_require__(981),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 980:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            carousel: 0,
            animated: 'fade',
            drag: false,
            autoPlay: false,
            pauseHover: false,
            pauseInfo: false,
            pauseType: 'is-primary',
            interval: 3000,
            carousels: [{ title: 'Slide 1', color: 'dark' }, { title: 'Slide 2', color: 'primary' }, { title: 'Slide 3', color: 'info' }, { title: 'Slide 4', color: 'success' }, { title: 'Slide 5', color: 'warning' }, { title: 'Slide 6', color: 'danger' }]
        };
    },

    methods: {
        info: function info(value) {
            this.carousel = value;
            this.$buefy.toast.open({
                message: 'This Slide ' + value + ' !',
                type: 'is-info'
            });
        }
    }
});

/***/ }),

/***/ 981:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticStyle: {
      "padding": "1.5rem"
    }
  }, [_c('b-field', {
    attrs: {
      "grouped": "",
      "group-multiline": "",
      "position": "is-centered"
    }
  }, [_c('b-switch', {
    model: {
      value: (_vm.autoPlay),
      callback: function($$v) {
        _vm.autoPlay = $$v
      },
      expression: "autoPlay"
    }
  }, [_vm._v("Autoplay")]), _vm._v(" "), _c('b-switch', {
    attrs: {
      "disabled": !_vm.autoPlay
    },
    model: {
      value: (_vm.pauseHover),
      callback: function($$v) {
        _vm.pauseHover = $$v
      },
      expression: "pauseHover"
    }
  }, [_vm._v("Pause on hover")]), _vm._v(" "), _c('b-switch', {
    attrs: {
      "disabled": !_vm.pauseHover
    },
    model: {
      value: (_vm.pauseInfo),
      callback: function($$v) {
        _vm.pauseInfo = $$v
      },
      expression: "pauseInfo"
    }
  }, [_vm._v("Pause info")]), _vm._v(" "), _c('b-switch', {
    model: {
      value: (_vm.drag),
      callback: function($$v) {
        _vm.drag = $$v
      },
      expression: "drag"
    }
  }, [_vm._v("Drag event")])], 1), _c('br'), _vm._v(" "), _c('b-field', {
    attrs: {
      "grouped": "",
      "group-multiline": "",
      "position": "is-centered"
    }
  }, [_c('b-field', {
    attrs: {
      "label": "Value"
    }
  }, [_c('b-numberinput', {
    attrs: {
      "min": "0",
      "max": _vm.carousels.length - 1,
      "controls-position": "compact"
    },
    model: {
      value: (_vm.carousel),
      callback: function($$v) {
        _vm.carousel = $$v
      },
      expression: "carousel"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Interval"
    }
  }, [_c('b-numberinput', {
    attrs: {
      "min": "0",
      "controls-position": "compact",
      "step": "1000",
      "disabled": !_vm.autoPlay
    },
    model: {
      value: (_vm.interval),
      callback: function($$v) {
        _vm.interval = $$v
      },
      expression: "interval"
    }
  })], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Animated"
    }
  }, [_c('b-field', [_c('b-radio-button', {
    attrs: {
      "native-value": "fade"
    },
    model: {
      value: (_vm.animated),
      callback: function($$v) {
        _vm.animated = $$v
      },
      expression: "animated"
    }
  }, [_vm._v("\n                            Fade\n                        ")]), _vm._v(" "), _c('b-radio-button', {
    attrs: {
      "native-value": "slide"
    },
    model: {
      value: (_vm.animated),
      callback: function($$v) {
        _vm.animated = $$v
      },
      expression: "animated"
    }
  }, [_vm._v("\n                            Slide\n                        ")])], 1)], 1), _vm._v(" "), _c('b-field', {
    attrs: {
      "label": "Pause Type"
    }
  }, [_c('b-select', {
    attrs: {
      "disabled": !_vm.pauseInfo
    },
    model: {
      value: (_vm.pauseType),
      callback: function($$v) {
        _vm.pauseType = $$v
      },
      expression: "pauseType"
    }
  }, [_c('option', {
    attrs: {
      "value": "is-white"
    }
  }, [_vm._v("is-white")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "is-dark"
    }
  }, [_vm._v("is-dark")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "is-primary"
    }
  }, [_vm._v("is-primary")])])], 1)], 1)], 1), _vm._v(" "), _c('b-carousel', {
    attrs: {
      "animated": _vm.animated,
      "has-drag": _vm.drag,
      "autoplay": _vm.autoPlay,
      "pause-hover": _vm.pauseHover,
      "pause-info": _vm.pauseInfo,
      "pause-info-type": _vm.pauseType,
      "interval": _vm.interval
    },
    on: {
      "change": function($event) {
        _vm.info($event)
      }
    },
    model: {
      value: (_vm.carousel),
      callback: function($$v) {
        _vm.carousel = $$v
      },
      expression: "carousel"
    }
  }, _vm._l((_vm.carousels), function(carousel, i) {
    return _c('b-carousel-item', {
      key: i
    }, [_c('section', {
      class: ("hero is-medium is-" + (carousel.color) + " is-bold")
    }, [_c('div', {
      staticClass: "hero-body has-text-centered"
    }, [_c('h1', {
      staticClass: "title"
    }, [_vm._v(_vm._s(carousel.title))])])])])
  }), 1)], 1)
},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/165.b41e4cb50aaabfc7e01e.js